import { RendererState } from '@src/renderer/RendererState';
import VideoCreatorStore, {
  KARAOKE_TRACK_NUMBER,
} from '@src/stores/VideoCreatorStore';
import { KaraokeConfig } from '@src/videoTranscriptionProcessor/types/karaokeTypes';

const manualChangeFields: (keyof KaraokeConfig)[] = ['width', 'x', 'y'];

function detectAndApplyManualChangesToKaraokeConfig(
  videoCreator: VideoCreatorStore,
  newState: RendererState,
): boolean {
  const activeElementOld = videoCreator.getActiveElement();
  if (!activeElementOld || activeElementOld.track !== KARAOKE_TRACK_NUMBER) {
    return false;
  }
  const activeElementNew = newState.elements.find(
    (el) => el.source.id === activeElementOld.source.id,
  );
  if (!activeElementNew) {
    return false;
  }

  const activeClip = videoCreator.karaokeProducer.getClipByText(
    activeElementNew.source.text,
  );
  const layoutType = activeClip?.getStackedLayoutType();
  const karaokeConfig = videoCreator.karaokeProducer.getKaraokeConfig();

  const propertyMap = manualChangeFields.reduce((acc, field) => {
    // no change
    if (activeElementNew.source[field] === activeElementOld.source[field]) {
      return acc;
    }

    // update variablePositionings instead of the field if layoutType is set
    let updatedVariablePositionings;
    if (
      layoutType &&
      (updatedVariablePositionings =
        videoCreator.karaokeProducer.getFullyUpdatedVariablePositionings(
          layoutType,
          field,
          activeElementNew.source[field],
        ))
    ) {
      acc.variablePositionings = updatedVariablePositionings;
    } else {
      acc[field] = activeElementNew.source[field];
    }

    return acc;
  }, {} as Partial<KaraokeConfig>);

  if (Object.keys(propertyMap).length) {
    const newConfig = { ...karaokeConfig, ...propertyMap };
    const cb = () => {
      videoCreator.textBrandingService.checkPropsChanged(
        'karaoke',
        propertyMap,
      );
      videoCreator.karaokeProducer.rerenderWithNewConfig(newConfig);
    };
    if (videoCreator.rootStore.videoSourceStore.hasDebouncedSourceRefresh) {
      videoCreator.rootStore.videoSourceStore.onNextSourceRefresh(cb);
    } else {
      cb();
    }
  }

  return false;
}

detectAndApplyManualChangesToKaraokeConfig.displayName =
  'detectAndApplyManualChangesToKaraokeConfig';

export default detectAndApplyManualChangesToKaraokeConfig;
